import styled, { DefaultTheme } from 'styled-components';
import { Card, Typography } from 'antd';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const ChartCard = styled(Card)`
  border-radius: 16px;
  border: 1px solid ${(props) => getThemeValue(props, '#4a5568', '#e5e7eb')};
  background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')};
  box-shadow: ${(props) =>
    getThemeValue(
      props,
      '0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
      '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
    )};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  width: 100%;

  .ant-card-body {
    padding: 16px;
    background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')};
    
    @media (min-width: 768px) {
      padding: 20px 24px;
    }
  }
`;

export const ChartContainer = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  gap: 12px;
`;

export const EmptyText = styled(Typography.Text)`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => getThemeValue(props, '#a0aec0', '#666')} !important;
  
  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const EmptyIconWrapper = styled.div`
  font-size: 48px;
  color: ${(props) => getThemeValue(props, '#4a5568', '#d1d5db')};
  opacity: 0.5;
  
  @media (max-width: 767px) {
    font-size: 36px;
  }
`;
